var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgGhLogo = function SvgGhLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220 100",
    style: {
      enableBackground: "new 0 0 220 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#07223C;}\r\n\t.st1{fill:#1373E6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "217.5,3.8 205.5,8.9 205.5,59.4 205.5,71.3 217.5,71.3 217.5,66.2 217.5,59.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.6,50.5c0-0.5,0-1-0.1-1.5V29.3h-11.9v2.2c-2.8-1.4-6-2.2-9.4-2.2c-11.8,0-21.4,9.5-21.4,21.3 c0,11.7,9.6,21.3,21.4,21.3c3.4,0,6.6-0.8,9.4-2.2v1.7h11.9V52C200.6,51.5,200.6,51,200.6,50.5 M179.2,59.9c-5.2,0-9.4-4.2-9.4-9.4 c0-5.2,4.2-9.4,9.4-9.4c5.2,0,9.4,4.2,9.4,9.4C188.6,55.7,184.4,59.9,179.2,59.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.8,29.3c-3.4,0-6.6,0.8-9.5,2.2V4.3l-11.9,5.1v40.2c0,0.3,0,0.6,0,0.9c0,0.3,0,0.6,0,0.9v0.3h0 c0.6,11.2,9.9,20.1,21.4,20.1c11.8,0,21.4-9.5,21.4-21.3C154.2,38.8,144.7,29.3,132.8,29.3 M132.8,59.9c-5.2,0-9.4-4.2-9.4-9.4 c0-5.2,4.2-9.4,9.4-9.4c5.2,0,9.4,4.2,9.4,9.4C142.3,55.7,138,59.9,132.8,59.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.3,29.3c-11.8,0-21.4,9.5-21.4,21.3c0,11.7,9.6,21.3,21.4,21.3c11.8,0,21.4-9.5,21.4-21.3 C107.7,38.8,98.1,29.3,86.3,29.3 M86.3,59.9c-5.2,0-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4c5.2,0,9.4,4.2,9.4,9.4 C95.7,55.7,91.5,59.9,86.3,59.9"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.1,3.8 49.1,8.9 49.1,59.4 49.1,71.3 61.1,71.3 61.1,66.2 61.1,59.4 61.1,3.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.1,29.3v2.2c-2.8-1.4-6-2.2-9.4-2.2C12,29.3,2.5,38.8,2.5,50.5c0,11.7,9.5,21.3,21.2,21.3 c11.7,0,21.2-9.5,21.2-21.3V29.3H33.1z M23.7,41.2c5.1,0,9.3,4.2,9.3,9.4c0,5.2-4.2,9.4-9.3,9.4c-5.2,0-9.3-4.2-9.3-9.4 C14.4,45.4,18.6,41.2,23.7,41.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,84.3c-5.2,0-9.3-4.2-9.3-9.4H2.5c0,11.7,9.5,21.3,21.2,21.3c11.7,0,21.2-9.5,21.2-21.3H33 C33,80.1,28.9,84.3,23.7,84.3"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGhLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GHLogo.dee0cb36.svg";
export { ForwardRef as ReactComponent };